import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {VisualizationMode} from '@/model/resource/VisualizationMode'

export class ListVisualizationModeSchema extends Schema {
  readonly name = 'ListVisualizationMode'

  readonly fieldSet: FieldSet<VisualizationMode> = {
    idVisualizationModePk: (): FieldComponent => ({
      is: Component.Render,
    }),
    description: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
